var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 121,
    viewBox: "0 0 67 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8649 41.9653C64.8649 41.8505 64.1378 43.6872 64.1378 43.6872C60.7131 50.9193 55.5664 58.0176 51.1659 64.0061C46.8802 69.8798 42.5945 75.6387 38.194 81.3977C33.6595 87.4053 29.1251 93.3939 24.6098 99.5163L13.2259 114.21H64.4057V120.83H0.119995L19.3483 95.4793C23.8827 89.4908 28.532 83.4831 33.0664 77.4755C37.3521 71.7166 41.7526 65.9576 46.0384 60.0839C50.3241 54.2102 55.1072 47.4755 58.7807 39.8798C59.3929 37.5456 59.8904 35.0966 59.8904 32.4181C59.8904 18.4512 48.87 7.44999 34.9032 7.44999C20.9363 7.44999 9.9159 18.4704 9.9159 33.6426H3.42994C3.42994 15.1604 17.7603 0.830078 34.9032 0.830078C52.046 0.830078 66.3764 15.2752 66.3764 32.4181C66.3764 35.728 65.8789 39.038 64.9031 41.9653H64.8649Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/NUMBER_2.0b7342d7aaeec5100d44c17d5fa77f0d.svg";
export { ForwardRef as ReactComponent };